function isElementInViewport(el) {
	//special bonus for those using jQuery
	if (typeof jQuery === 'function' && el instanceof jQuery) {
		el = el[0];
	}
	var rect = el.getBoundingClientRect();
	return (
		rect.top + el.offsetHeight >= 0 &&
		rect.left + el.offsetWidth >= 0 &&
		rect.bottom <= ((window.innerHeight || document.documentElement.clientHeight) + el.offsetHeight) && /*or $(window).height() */
		rect.right <= ((window.innerWidth || document.documentElement.clientWidth) + el.offsetWidth) /*or $(window).width() */
	);
}
function checkViewport() {
	$('.check-viewport').each(function () {
		if (isElementInViewport(this)) {
			if (!$(this).hasClass('visible')) {
				$(this).addClass('visible');
				$(this).trigger('show');
			}
		} else {
			if ($(this).hasClass('visible')) {
				$(this).removeClass('visible');
				$(this).trigger('hide');
			}
		}
	});
}
$(document).ready(checkViewport);
$(window).scroll(checkViewport);



// WEBPACK FOOTER //
// ./temp/components/core/viewport.js